var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-button',_vm._g(_vm._b({attrs:{"dark":"","text":"","color":"grey"}},'base-button',_vm.$attrs,false),_vm.$listeners),[_c('v-icon',[_vm._v("delete_outline")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }